import { useState, useContext, useEffect } from "react";
import {
    fetchedSalesAccumulative,
    fetchedVehiclesBySubsidiary,
    fetchedUsersByGang,
} from "../../../apis/apis.dispatches/apisDispatch";
import { getCurrentDate } from "../../../configs/helpers";
import { toast } from "react-toastify";
import { ContextAuth } from "../../../contexts/ContextAuth";

const inputCls = "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
const labelCls = "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

export function AccumulativeDispatchFilter({
    setOrders,
    vehicles,
    setVehicles,
    users,
    setUsers,
    operationStatus,
    ordersCount,
}) {
    const { auth } = useContext(ContextAuth);

    const [questionState, setQuestionState] = useState({
        startDate:       getCurrentDate("-"),
        subsidiaryID:    auth.data.subsidiary.subsidiary_id,
        gangID:          0,
        userID:          0,
        operationStatus: "02",
    });

    const getVehicles = async (id) => {
        try { setVehicles(await fetchedVehiclesBySubsidiary({ subsidiaryID: id })); }
        catch (e) { throw e; }
    };

    const getUsersByGang = async (id) => {
        try { setUsers(await fetchedUsersByGang({ gangID: id })); }
        catch (e) { throw e; }
    };

    const searchSuggestions = async () => {
        if (questionState.gangID <= 0) { toast.info("Elija una cuadrilla"); return; }
        try {
            const res = await fetchedSalesAccumulative(questionState);
            setOrders(res);
            const n = res.length;
            toast.info(n > 1 ? `Se encontraron ${n} resultados.` : `Se encontró ${n} resultado(s).`);
        } catch (e) { throw e; }
    };

    useEffect(() => { getVehicles(auth.data.subsidiary.subsidiary_id); }, []);

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                <div>
                    <h2 className="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                        <i className="fas fa-filter text-blue-500"></i>
                        Filtros de búsqueda
                    </h2>
                </div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-100 dark:bg-gray-700 px-3 py-1 text-xs font-medium text-gray-600 dark:text-gray-300">
                    <span className="h-1.5 w-1.5 rounded-full bg-blue-500"></span>
                    {ordersCount} registros
                </span>
            </div>

            <div className="px-5 py-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 items-end">

                    {/* Ruta */}
                    <div className="lg:col-span-2">
                        <label className={labelCls}><i className="fas fa-route mr-1"></i>Ruta</label>
                        <select
                            name="gangID"
                            value={questionState.gangID}
                            onChange={(e) => {
                                setQuestionState({ ...questionState, gangID: e.target.value });
                                getUsersByGang(e.target.value);
                            }}
                            className={inputCls}
                        >
                            <option value={0}>Seleccionar ruta...</option>
                            {vehicles.map((item, i) => (
                                <option key={i} value={item.gang.gangID}>
                                    {item.vehicleLicensePlate} | {item.gang.gangName}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Usuario */}
                    <div className="lg:col-span-1">
                        <label className={labelCls}><i className="fas fa-user mr-1"></i>Usuario</label>
                        <select
                            name="userID"
                            value={questionState.userID}
                            onChange={(e) => setQuestionState({ ...questionState, userID: e.target.value })}
                            className={inputCls}
                        >
                            <option value={0}>Todos</option>
                            {users.map((item, i) => (
                                <option key={i} value={item.id}>
                                    {item.first_name} | {item.last_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Tipo de pedido */}
                    <div className="lg:col-span-1">
                        <label className={labelCls}><i className="fas fa-shopping-cart mr-1"></i>Tipo de Pedido</label>
                        <select
                            name="operationStatus"
                            value={questionState.operationStatus}
                            onChange={(e) => setQuestionState({ ...questionState, operationStatus: e.target.value })}
                            className={inputCls}
                        >
                            {operationStatus.map((item, i) => (
                                <option key={i} value={item.id}>{item.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Fecha */}
                    <div className="lg:col-span-1">
                        <label className={labelCls}><i className="fas fa-calendar mr-1"></i>Fecha</label>
                        <input
                            type="date"
                            name="startDate"
                            value={questionState.startDate}
                            onChange={(e) => setQuestionState({ ...questionState, startDate: e.target.value })}
                            className={inputCls}
                        />
                    </div>

                    {/* Buscar */}
                    <div className="lg:col-span-1">
                        <button
                            id="btn-filter"
                            onClick={searchSuggestions}
                            className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                        >
                            <i className="fas fa-search"></i>
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
